import Image from "next/image";
import Link from "next/link";
import styles from "./AdminOnboardingBottomArea.module.css";

function AdminOnboardingBottomArea(): JSX.Element {
  return (
    <div className={styles.bottomLayer}>
      <div className="w-full flex phone:flex-col pt-20 phone:pt-10">
        <div className="w-1/2 phone:w-full flex flex-col">
          <Link href="/">
            <a>
              <Image
                src="/images/logo-white.svg"
                alt="MyEdVault"
                width={230}
                height={40}
              />
            </a>
          </Link>
          <div className="w-[50%] phone:border-b border-white phone:pb-4  phone:w-full font-normal mt-8 text-[16px] leading-[150%] text-white ">
            Master your training programs with effortless control, precise
            customization, and breakthrough results that drive success.
          </div>
        </div>
        <div className="w-1/2 phone:w-full flex flex-col text-white phone:px-0 phone:mt-6 px-36">
          <div className="text-[24px] leading-[150%] font-medium">Company</div>
          <div className={styles.bottomLink}>
            <Link href="/admin-portal/onboarding/about-us">
              <a>About Us</a>
            </Link>
            <Link href="/privacy-policy">
              <a>Privacy Policy</a>
            </Link>
            <Link href="/cookies">
              <a>Cookies Policy</a>
            </Link>
            <Link href="/admin-portal/onboarding/contact-us">
              <a>Contact Us</a>
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full border-t border-white py-8 phone:mt-6 text-[14px] text-white leading-[150%] flex justify-center items-center font-light">
        <span className="mr-2 text-[16px]">&#169;</span>
        <span> 2024 All Rights Reserved</span>
      </div>
    </div>
  );
}

export default AdminOnboardingBottomArea;
